import * as next from '../../../types/next'
import type { BlockUiSchema } from '../../../utils'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.ActionBarBlock> = (
  uischema: BlockUiSchema
) => {
  if (uischema.type !== CONTROL_NAME.ACTION_BAR_CONTROL) {
    throw new Error('Expected a valid Action Bar control')
  }
  const options = uischema.options || {}

  return {
    type: next.BLOCK_TYPE.ACTION_BAR,
    settings: {
      ...upCommonSettings(uischema),
      next: upNextButton(options.ctaButton),
      back: upBackButton(options.goBackButton)
    }
  }
}

const upNextButton = (
  nextButton: any
): next.NextButton | next.HiddenNextButton => {
  const display = Boolean(nextButton.isVisible) ?? false

  if (!display) {
    return {
      display: false
    } as next.HiddenNextButton
  }

  return {
    display: display,
    label: nextButton.label,
    action:
      nextButton.actionType === 'GoNext'
        ? next.ACTION_BAR_ACTION_TYPE.NAVIGATE_ONLY
        : next.ACTION_BAR_ACTION_TYPE.SUBMIT_AND_NAVIGATE,
    nextStep: nextButton.targetStepId
  } as next.NextButton
}

const upBackButton = (
  backButton: any | undefined
): next.BackButton | next.HiddenBackButton | undefined => {
  if (!backButton) {
    return
  }
  const display = Boolean(backButton.isVisible) ?? false

  if (!display) {
    return {
      display: false
    } as next.HiddenBackButton
  }

  return {
    display: display,
    label: backButton.label
  } as next.BackButton
}
